module.exports = __webpack_public_path__ + "static/media/gen_oth_hou.467b53c1.png";